import React from "react";
import { Spinner } from "@blueprintjs/core";
import BaseTable, { Column, AutoResizer, SortOrder } from "react-base-table";
import styles from "./CashOutOverview.module.scss";

const CashOutList = ({
  isLoading,
  loadingMore,
  payments,
  columns,
  columnWidths,
  sort,
  onSortPress,
  onColumnResize,
  getColumnWidth,

}) => {

  return (
    <AutoResizer>
      {({ width, height }) => (
        <BaseTable
          fixed
          loadingMore={loadingMore}
          data={payments}
          width={width}
          height={height}
          emptyRenderer={
            <div className={styles.empty}>
              {isLoading ? <Spinner /> : "No Transactions Found"}
            </div>
          }
          sortBy={{
            key: sort.field,
            order: sort.direction === "asc" ? SortOrder.ASC : SortOrder.DESC
          }}
          onColumnSort={({ key, order }) => onSortPress(key, order)}
          onColumnResizeEnd={onColumnResize}
          className={styles.dataTable}
        >
          {columns.map((column, index) => (
            <Column
              {...column}
              width={getColumnWidth({ columnWidths, index, width })}
            />
          ))}
        </BaseTable>
      )}
    </AutoResizer>
  );
};

export default CashOutList;
